import { useState } from 'react';
import { adminFetch } from '../lib/api';

export function LoginForm({ onSuccess }: { onSuccess: () => void }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError('');
    try {
      // The API also sets an HttpOnly cookie; the browser sends it from here on.
      await adminFetch('/auth/login', {
        method: 'POST',
        body: JSON.stringify({ username, password }),
      });
      onSuccess();
    } catch {
      // Never echo the server's message: it distinguishes a bad user from a bad
      // password and feeds credential stuffing.
      setError('Invalid credentials');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div id="login-container">
      <h1>Zen Bell</h1>
      <p>Admin Dashboard</p>
      {error ? <div id="login-error" style={{ display: 'block' }}>{error}</div> : null}
      <form id="login-form" onSubmit={submit}>
        <input
          id="username"
          type="text"
          placeholder="Username"
          autoComplete="username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          required
        />
        <input
          id="password"
          type="password"
          placeholder="Password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
        <button type="submit" disabled={busy}>{busy ? 'Checking…' : 'Access'}</button>
      </form>
    </div>
  );
}
